import type { FC } from "react";
import React from "react";

import { GRID_COLUMNS } from "../../../bootstrap/grid.ts";

interface GridLegendProps {
  readonly squareKcal: number;
}

export const GridLegend: FC<GridLegendProps> = ({ squareKcal }) => {
  const squareLegend = `1 square = ${squareKcal.toLocaleString()} kcal`;

  const lineKcal = (squareKcal * GRID_COLUMNS).toLocaleString();
  const lineLegend = `1 line = 1 day · ${lineKcal} kcal`;

  return (
    <div className="flex shrink-0 items-center justify-between border-b bg-card px-4 py-[7px] font-mono text-[11px] text-muted-foreground">
      <span>{squareLegend}</span>
      <span>{lineLegend}</span>
    </div>
  );
};
